module.exports = __webpack_public_path__ + "static/media/Montserrat-Thin.426a4b74.ttf";